import { environment as env } from '@/env/environment';
import { inject } from '@angular/core';

export function getLanguage() {
    if (typeof window === 'undefined') {
        return 'es';
    }

    const paths = window.location.href.split('/');
    const language = paths.find((path) => env.allowedLanguages.includes(path));

    return language ?? 'es';
}
